import axios from "axios";

const getReservedTimeSlotsForUsers = (userIds, hook) => {
    const token = localStorage.getItem('access_token');
    axios
    .get(`${process.env.REACT_APP_API_BASE_URL}/api/get-reserved-timeslots-for-users/${userIds.join(',')}`,{
        headers: {
            Authorization: `Bearer ${token}`,
        },
    })
    .then((response) => {
        if (response.data) {
            hook(response.data);
        }
    })
    .catch((error) => {
        console.error("Failed to fetch user info:", error);
    });
};

export default getReservedTimeSlotsForUsers;